<a *ngIf="links.length === 1" class="ml-2 text-nowrap" target="_blank" [href]="links[0].url">
  <i class="far fa-truck mr-1"></i>{{ 'TRACK_ORDER' | translate }}
</a>

<span *ngIf="links.length > 1" class="d-flex flex-column">
  <a
    *ngFor="let link of links"
    class="mt-1 text-nowrap"
    target="_blank"
    [href]="link.url"
    [title]="'TRACK_ORDER' | translate"
  >
    <i class="far fa-truck fa-fw mr-1"></i>{{ link.packageNumber }}
  </a>
</span>
